import { render } from "./ThePatientConsultationShow.vue?vue&type=template&id=5ae9b312&scoped=true&ts=true"
import script from "./ThePatientConsultationShow.vue?vue&type=script&lang=ts"
export * from "./ThePatientConsultationShow.vue?vue&type=script&lang=ts"

import "./ThePatientConsultationShow.vue?vue&type=style&index=0&id=5ae9b312&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae9b312"]])

export default __exports__